{
  "info": "資訊",
  "negative": "錯誤",
  "positive": "成功"
}
